handleUserEmailPreferencesById